import config from './config'
import detect from './detect'
import dom from './dom'

export { config, detect, dom }
